import { memo, useMemo } from "react";

import { Breadcrumbs } from "@components/Breadcrumbs";
import { useCollectionQuery } from "@react/sections/Collection/useCollectionQuery";

interface Props {
  breadcrumbsLabel: string;
  collectionHandle: string;
  homeLabel: string;
  homeUrl: string;
  isLoading?: boolean;
}

const CollectionBreadcrumbsBase = ({
  breadcrumbsLabel,
  collectionHandle,
  homeLabel,
  homeUrl,
  isLoading = false,
}: Props) => {
  const { breadcrumbs, handle, title } = useCollectionQuery(collectionHandle);

  const breadcrumbLinks = useMemo(() => {
    const collectionUrl = `/collections/${handle}`;

    return [
      ...(breadcrumbs?.map((breadcrumb) => ({
        title: breadcrumb.titleOverride?.value ?? breadcrumb.title,
        url: breadcrumb.onlineStoreUrl ?? undefined,
      })) ?? []),
      { title: title ?? "", url: collectionUrl },
    ];

    return [];
  }, [breadcrumbs, handle, title]);

  return (
    <Breadcrumbs
      breadcrumbsLabel={breadcrumbsLabel}
      homeLabel={homeLabel}
      homeUrl={homeUrl}
      isLoading={isLoading}
      items={breadcrumbLinks}
    />
  );
};

export const CollectionBreadcrumbs = memo(CollectionBreadcrumbsBase);
